import AirCon from "../assets/air-conditioner.jpg";
import Gator from "../assets/alligator.jpg";
import Asthma from "../assets/asthma.jpg";
import Basement from "../assets/basement.jpg";
import Cyclone from "../assets/cyclone.jpg";
import Dizzy from "../assets/dizzy.jpg";
import Dog from "../assets/dog.jpg";
import Drapes from "../assets/drapes.jpg";
import Debris from "../assets/flood-debris.jpg";
import Truck from "../assets/flood-truck.jpg";
import Wading from "../assets/flood-wading.jpg";
import Frostbite from "../assets/frostbite.jpg";
import Furniture from "../assets/furniture.jpg";
import Jumper from "../assets/jumper-cables.jpg";
import Cramp from "../assets/muscle-cramp.jpg";
import PowerE from "../assets/power-electricity.jpg";
import PowerU from "../assets/power-unplug.jpg";
import Detector from "../assets/smoke-detector.jpg";
// import SLand from "../assets/snow-land.jpg";
import SClothes from "../assets/summer-clothes.jpg";
import Hydrate from "../assets/water-hydration.jpg";
// import Frost from "../assets/window-frost.jpg";
import Windows from "../assets/windows-multi.jpg";
import WTrees from "../assets/winds-trees.jpg";
import WClothes from "../assets/winter-clothes.jpg";
// import WLand from "../assets/winter-landscape.jpg";
import WWoman from "../assets/winter-woman.jpg";

export const HeatList = [
  {
    name: "House",
    image: Drapes,
    desc: "Cover windows with drapes or shades.  Add insulation to keep the heat out.",
  },
  {
    name: "House",
    image: AirCon,
    desc: "Install window air conditioners and insulate around them.",
  },
  {
    name: "General",
    image: SClothes,
    desc: "Wear loose, lightweight, light-colored clothing.  Take cool showers or baths.  Never leave pets in a closed car.",
  },
  {
    name: "General",
    image: Hydrate,
    desc: "Drink plenty of fluids to stay hydrated.  Go to a location with cooling.  Check on family members.",
  },
  {
    name: "Heat Cramps",
    image: Cramp,
    desc: "Muscle pains or spasms in the stomach, arms or legs",
  },
  {
    name: "Heat Exhaustion",
    image: Dizzy,
    desc: "Heavy sweating, paleness, muscle cramps, tiredness, weakness, fast or weak pulse, dizziness, headache, fainting, nausea, vomiting",
  },
];


export const ColdList = [
  {
    name: "Power",
    image: PowerE,
    desc: "Generators can be helpful when the power goes out.  Beware of carbon monoxide poisoning.  Use generators outdoors.",
  },
  {
    name: "Power",
    image: Detector,
    desc: "Install and test smoke alarms and carbon monoxide detectors.  Have extra batteries.",
  },
  {
    name: "Prepare",
    image: Jumper,
    desc: "Create an emergency supply kit for your car.  Include jumper cables, sand, a flashlight, warm clothes, blankets, bottled water, snacks, & gas.",
  },
  {
    name: "Clothing",
    image: WClothes,
    desc: "Wear a baselayer, thermals, wool socks, quality shoes, and layer your clothing.",
  },
  {
    name: "Frostbite",
    image: Frostbite,
    desc: "Numbness, white or grayish-yellow skin, firm skin.  Go to a warm room. Soak in warm water. Use body heat to warm. Do not massage or use a heating pad.",
  },
  {
    name: "Hypothermia",
    image: WWoman,
    desc: "Shivering, exhaustion, confusion, fumbling hands, memory loss, slurred speech or drowsiness. Warm the center of the body first—chest, neck, head and groin. ",
  },
];

export const WindList = [
  {
    name: "General",
    image: Basement,
    desc: "Go to a safe shelter immediately, such as a safe room, basement, storm cellar or a small interior room on the lowest level of a sturdy building.",
  },
  {
    name: "General",
    image: Windows,
    desc: "Stay away from windows, doors, and outside walls.",
  },
  {
    name: "Prepare",
    image: WTrees,
    desc: "Sign up for your community's warning system.  Pay attention to weather reports.",
  },
  {
    name: "Prepare",
    image: Dog,
    desc: "Plan for your pet and include them in your family's emergency plan",
  },
  {
    name: "Protection",
    image: Furniture,
    desc: "Cover your head or neck with your arms and putting materials such as furniture and blankets around you.",
  },
  {
    name: "Protection",
    image: Cyclone,
    desc: "Do not try to outrun a tornado in a vehicle.  Try to get inside a building.",
  },
];

export const FloodList = [
  {
    name: "General",
    image: Truck,
    desc: "Do not swim or drive through flood waters.",
  },
  {
    name: "General",
    image: Wading,
    desc: "6 inches can knock you down, 1 foot of water can sweep your vehicle away.",
  },
  {
    name: "General",
    image: Gator,
    desc: "Be aware of snakes, gators, and other animals in the water",
  },
  {
    name: "Power",
    image: PowerU,
    desc: "Use a generator or other gasoline-powered machinery ONLY outdoors and away from windows.  Turn off electricity to prevent shock.",
  },
  {
    name: "Power",
    image: Debris,
    desc: "Avoid wading in floodwater which may have dangerous debris and downed power lines.",
  },
  {
    name: "Health",
    image: Asthma,
    desc: "People with asthma or other lung conditions and/or immune suppresion should not enter buildings with indoor water leaks or mold growth.",
  },
];